import { Component, OnInit } from '@angular/core';
import {EmailTrackerService} from "../../providers/email-tracker.service";
import {LoadingServiceProvider} from "../../providers/loading-service";
import {ShortUrlService} from "../../providers/short-url.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-email-tracker',
  templateUrl: './email-tracker.component.html',
  styleUrls: ['./email-tracker.component.scss']
})
export class EmailTrackerComponent implements OnInit {
  newNote = '';
  newUrl = '';

  emailTracker = {
    to: '',
    from: '',
    name: '',
    notes: '',
    title: '',
    tags: [],
    status: '1st Email Sent',
    facilityName: '',
    website: '',
    city: '',
    state: ''
  };

  imageUrl = '';
  filteredEmails: any[];
  filteredFacilityName: any[];
  filteredTags: any[];
  filteredCities: any[];
  filteredStates: any[];

  status = [
    {label: '1st Email Sent', value: '1st Email Sent'},
    {label: 'No Email Sent', value: 'No Email Sent'},
    {label: 'Call', value: 'Call'},
    {label: 'Cold', value: 'Cold'},
    {label: 'Follow Up Email Sent', value: 'Follow Up Email Sent'},
    {label: 'Need To Respond', value: 'Need To Respond'},
    {label: 'Not Interested', value: 'Not Interested'},
    {label: 'Response Sent', value: 'Response Sent'},
  ];

  colors = {
    '1st Email Sent': '#FFCC80',
    'No Email Sent': '#78909C',
    'Not Interested': '#BDBDBD',
    'Cold': '#03A9F4',
    'Call': '#7E57C2',
    'Follow Up Email Sent': '#FF9800',
    'Need To Respond': '#4CAF50',
    'Response Sent': '#8D6E63',
  };

  constructor(
    public et: EmailTrackerService,
    private loading: LoadingServiceProvider,
    public shortUrl: ShortUrlService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.et.emailTrackersArray = [];
    this.et.getAllTrackers().toPromise().then(trackers => {
      console.log(trackers);
      this.et.emailTrackers = trackers;
      let count = 0;

      for(let id in trackers) {
        let tmp = trackers[id];
        tmp.position = count;

        count++;
        this.et.emailTrackersArray.push(tmp);
      }
    });

    // this.et.makeNewEmailTrackers('test', 'test@test.com', 'yoyoyoy').toPromise().then(trackers => {
    //   console.log(trackers);
    // });;
  }

  addTag() {
    console.log(this.emailTracker.tags)
  }

  addNewNote(tracker) {
    this.loading.showLoading();
    tracker.notes.push(this.newNote);
    this.et.updateTracker(tracker.id, tracker).toPromise().then((data) => {
      this.newNote = '';
      this.loading.hideLoading();
      this.et.openSnackBar('Note Added Successfully.');
    }).catch(e => {
      console.log('error: ', e)
    });
  }

  goToLinkGraph(url) {
    this.loading.showLoading();
    this.shortUrl.getStatsByUrl(url).toPromise().then((stats) => {
      this.shortUrl.shortLinkStats = stats;
      this.shortUrl.shortLinkUrl = url;
      this.loading.hideLoading();
      this.router.navigate(['short-url-graph']);
    }).catch(e => {
      this.loading.hideLoading();
    });
  }

  addNewUrl(id) {
    this.loading.showLoading();
    this.et.generateShortUrl(this.newUrl, id).toPromise().then((data) => {
      console.log(data);

      for(let et of this.et.emailTrackersArray) {
        if(et.id == id) {
          et.urls.push({
            short: data.shortUrl,
            full: this.newUrl
          });
          et.clicks[data.shortUrl] = 0;
          this.newUrl = '';
          this.loading.hideLoading();
          this.et.openSnackBar('URL Added Successfully.');
          break;
        }
      }
    }).catch(e => {
      console.log(e);
      this.loading.hideLoading();
    });
  }

  addSpecificUrl(id, type) {
    if(type == 'video') {
      this.newUrl = 'https://storagepug.com/story';
    }
    else if(type == 'demo') {
      this.newUrl = 'https://demo.storagepug.com';
    }
    else if(type == 'storagepug') {
      this.newUrl = 'https://storagepug.com';
    }
    this.addNewUrl(id);
  }

  makeNewTracker() {
    if(this.emailTracker.to != '' && this.emailTracker.from != '' && this.emailTracker.title != '') {
      this.loading.showLoading();

      let noteArray = [this.emailTracker.notes];
      this.et.makeNewEmailTrackers(this.emailTracker, noteArray).toPromise().then((data) => {
        this.et.getAllTrackers().toPromise().then(trackers => {
          console.log(trackers);
          this.et.emailTrackersArray = [];
          this.et.emailTrackers = trackers;
          let count = 0;

          this.emailTracker.to = '';
          this.emailTracker.from = '';
          this.emailTracker.title = '';
          this.emailTracker.name = '';
          this.emailTracker.notes = '';
          this.emailTracker.city = '';
          this.emailTracker.state = '';
          this.emailTracker.website = '';
          this.emailTracker.facilityName = '';
          this.emailTracker.tags = [];

          this.imageUrl = data.imgUrl;

          for (let id in trackers) {
            let tmp = trackers[id];
            tmp.position = count;
            count++;
            this.et.emailTrackersArray.push(tmp);
          }

          this.et.openSnackBar('New Tracker Successfully created.');
          this.loading.hideLoading();
        });

      }).catch(e => {
        console.log(e)
      });
    }
  }

  toggleNotifications(id) {
    if(this.et.emailTrackers[id].isNotifications == true) {
      this.et.emailTrackers[id].isNotifications = false;
    }
    else {
      this.et.emailTrackers[id].isNotifications = true;
    }
    this.et.updateTracker(id, this.et.emailTrackers[id]).toPromise().then((data) => {
      console.log(data);
      this.et.openSnackBar('Notification Settings updated Successfully.')
    }).catch(e => {
      console.log('error: ', e)
    })
  }

  updateEmailTracker(e) {
    this.et.updateTracker(e.data.id, e.data).toPromise().then((data) => {
      this.et.openSnackBar('Email tracker updated Successfully.')
    }).catch(e => {
      console.log('error: ', e)
    })
  }

  updateStatus(et) {
    console.log(et)
    this.et.updateTracker(et.id, et).toPromise().then((data) => {
      this.et.openSnackBar('Email tracker updated Successfully.')
    }).catch(e => {
      console.log('error: ', e)
    });
  }

  updateTags(et, e) {


  }

  toggleActive(id) {
    if(this.et.emailTrackers[id].isActive == true) {
      this.et.emailTrackers[id].isActive = false;
    }
    else {
      this.et.emailTrackers[id].isActive = true;
    }
    this.et.updateTracker(id, this.et.emailTrackers[id]).toPromise().then((data) => {
      this.et.openSnackBar('Active Settings updated Successfully.')
    }).catch(e => {
      console.log('error: ', e)
    })
  }

  filter(event, type) {
    let query = event.query;
    if(type == 'emails') {
      var data = this.et.emails;
    }
    else if(type == 'facilityNames') {
      var data = this.et.facilityNames;
    }
    else if(type == 'tags') {
      var data = this.et.tags;
    }
    else if(type == 'cities') {
      var data = this.et.cities;
    }
    else if(type == 'states') {
      var data = this.et.states;
    }

    let filtered : any[] = [];
    for(let i = 0; i < data.length; i++) {
      let country = data[i];
      if(country.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(country);
        console.log(filtered)
      }
    }
    if(type == 'emails') {
      this.filteredEmails = filtered;
    }
    else if(type == 'facilityNames') {
      this.filteredFacilityName = filtered;
    }
    else if(type == 'tags') {
      this.filteredTags = filtered;
      if(this.filteredTags.length == 0 || this.filteredTags.length > 1) {
        this.filteredTags.push(query);
      }
    }
    else if(type == 'cities') {
      this.filteredCities = filtered;
    }
    else if(type == 'states') {
      this.filteredStates = filtered;
    }

  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/email-tracker/email-tracker.component.ts